export default "__VITE_PUBLIC_ASSET__f42ce022__"